import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import BagikanUndangan from "./pages/BagikanUndangan";
import AuthCallback from "./pages/AuthCallback";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Pengumuman from "./pages/Pengumuman";
import Iuran from "./pages/Iuran";
import KasRT from "./pages/KasRT";
import DataWarga from "./pages/DataWarga";
import LaporanKejadian from "./pages/LaporanKejadian";
import Kegiatan from "./pages/Kegiatan";
import JadwalSatpam from "./pages/JadwalSatpam";
import IdentitasSatpam from "./pages/IdentitasSatpam";
import LayananLingkungan from "./pages/LayananLingkungan";
import ArsipLaporan from "./pages/ArsipLaporan";
import Galeri from "./pages/Galeri";
import SuratMenyurat from "./pages/SuratMenyurat";
import UMKM from "./pages/UMKM";
import KontakDarurat from "./pages/KontakDarurat";
import UserManagement from "./pages/UserManagement";
import Pengaturan from "./pages/Pengaturan";

const RequireAuth = ({ children, roles }) => {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

// Route-level role guards (module constants to avoid new array references per render)
const ADMIN_ROLES = ["admin", "super_admin"];
const SUPER_ADMIN_ONLY = ["super_admin"];

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: Handle Emergent OAuth callback synchronously — must run BEFORE ProtectedRoute
  if (typeof window !== "undefined" && location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/bagikan-undangan" element={<BagikanUndangan />} />
      <Route path="/" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
        <Route index element={<Dashboard />} />
        <Route path="pengumuman" element={<Pengumuman />} />
        <Route path="iuran" element={<Iuran />} />
        <Route path="kas" element={<RequireAuth roles={ADMIN_ROLES}><KasRT /></RequireAuth>} />
        <Route path="data-warga" element={<RequireAuth roles={ADMIN_ROLES}><DataWarga /></RequireAuth>} />
        <Route path="laporan" element={<LaporanKejadian />} />
        <Route path="kegiatan" element={<Kegiatan />} />
        <Route path="jadwal-satpam" element={<JadwalSatpam />} />
        <Route path="identitas-satpam" element={<RequireAuth roles={ADMIN_ROLES}><IdentitasSatpam /></RequireAuth>} />
        <Route path="layanan-lingkungan" element={<LayananLingkungan />} />
        <Route path="arsip-laporan" element={<ArsipLaporan />} />
        <Route path="galeri" element={<Galeri />} />
        <Route path="surat" element={<SuratMenyurat />} />
        <Route path="umkm" element={<UMKM />} />
        <Route path="kontak-darurat" element={<KontakDarurat />} />
        <Route path="user-management" element={<RequireAuth roles={SUPER_ADMIN_ONLY}><UserManagement /></RequireAuth>} />
        <Route path="pengaturan" element={<RequireAuth roles={SUPER_ADMIN_ONLY}><Pengaturan /></RequireAuth>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
